import Vue from 'vue';
// import vueSmoothScroll from 'vue-smoothscroll';
import router from './router';
import layoutPage from './layoutPage';
import VueLazyload from 'vue-lazyload';
import Vuelidate from 'vuelidate';
import VueMeta from 'vue-meta';

Vue.use(VueMeta);
Vue.use(Vuelidate);
Vue.use(require('vue-moment'));
// Vue.use(VueLazyload)
// or with options
// const loadimage = require('./assets/images/loader.gif')

Vue.use(VueLazyload, {
  // preLoad: 1.3,
  // loading: loadimage,
  // attempt: 1
  // listenEvents: "animationend"
})
// import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload, {
//   lazyComponent: true
// });
// Vue.use(vueSmoothScroll);

/*
         * requestAnimationFrame pollyfill
         */

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#mobilityintel',
  components: { layoutPage },router,
  template: '<layoutPage/>',
});



// WEBPACK FOOTER //
// ./src/main.js